import { createContext } from 'react';

const TableContext = createContext();

TableContext.displayName = 'TableContext';

export default TableContext;
